<template lang="pug">
el-collapse#card-dados-territorio-relatorio(v-model='collapse')
    el-collapse-item.pb-0(name='item')
        header.p-2(slot='title')
            .esquerda
                span {{ index + 1 }}
                h3 {{ territorio.nome }}

            .direita
                h3.mr-2.p-1 {{ territorio.localidade }}
                BaseButton.buttonLaudoDanger(
                    type='danger',
                    icon='el-icon-delete',
                    @click='$emit("removerTerritorio", territorio.id)'
                )

        el-form.form.p-2(label-position='top', size='small')
            .box
                .box-esquerda
                    ComercializacaoTerritorio(
                        @getComercializacao='getComercializacao',
                        :comercializacaoSelected='territorio.comercializacoes'
                    )
                .box-direita
                    .mapa
                        Mapa(
                            :mapLayersConfigs='layersMaps',
                            :mapConfig='mapConfig',
                            :height='"100%"',
                            :idMapa='String(territorio.id)',
                            locked
                        )
</template>

<script>
import ComercializacaoTerritorio from '@/components/compartilhamentoDados/Comercializacao';
import { getEstiloGeometria } from '@/utils/mapa/mapa.estilos';
import Mapa from '@/components/MapaLeaflet.vue';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'CardDadosTerritorioBenfeitorias',
    emits: ['removerTerritorio', 'getDados', 'getValidacao'],
    components: {
        ComercializacaoTerritorio,
        Mapa,
        BaseButton
    },
    props: {
        territorio: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            default: 0
        },
        valido: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            collapse: ['item'],
            isValidoEdit: true,
            layersMaps: [],
            mapConfig: {
                controls: {}
            },
            comercializacoes: null
        };
    },

    mounted() {
        this.$emit('getValidacao', {
            valido: this.isValidoEdit,
            id: this.territorio.id
        });
        this.$emit('getDados', {
            comercializacoes: this.territorio.comercializacoes,
            id: this.territorio.id,
            editado: false
        });
        this.mostrarTerritorioNoMapa();
    },

    methods: {
        mostrarTerritorioNoMapa() {
            this.layersMaps = [];

            let layerTerritorio = {
                style: getEstiloGeometria('area'),
                name: this.territorio.id,
                geoJson: this.territorio.geometria
            };

            this.layersMaps.push(layerTerritorio);
        },
        validarComercializacao() {
            let valido = true;
            if (this.comercializacoes) {
                for (var i = 0; i < this.comercializacoes.length; i = i + 1) {
                    if (
                        !this.comercializacoes[i].produto.id ||
                        this.comercializacoes[i].quantidade === 0 ||
                        !this.comercializacoes[i].unidadeMedida.id
                    ) {
                        valido = false;
                    }

                    if (
                        !this.comercializacoes[i].produto.id &&
                        !this.comercializacoes[i].quantidade &&
                        !this.comercializacoes[i].unidadeMedida.id &&
                        i === 0
                    ) {
                        valido = true;
                    }
                }
            }
            return valido;
        },
        getComercializacao(comercializacoes) {
            this.comercializacoes = comercializacoes;

            if (!this.validarComercializacao()) {
                this.isValidoEdit = false;
            } else {
                this.isValidoEdit = true;
            }
            this.$emit('getValidacao', {
                valido: this.isValidoEdit,
                id: this.territorio.id
            });
            this.$emit('getDados', {
                comercializacoes: this.comercializacoes,
                id: this.territorio.id,
                editado: true
            });
        }
    }
};
</script>

<style lang="scss">
#card-dados-territorio-relatorio {
    background-color: var(--white);
    border-radius: 4px;
    overflow: hidden;

    header {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 0px !important;

        .esquerda,
        .direita {
            display: flex;
            align-items: center;
            justify-content: space-between;

            gap: 4px;
        }

        .esquerda {
            span {
                color: var(--gray);
                font-size: 12px;
            }
        }

        .direita {
            h3 {
                background-color: var(--default-border-color);
                border-radius: 4px;
            }
        }
    }

    .form {
        .produtor .outro .input {
            display: flex;
            justify-content: space-between;

            .nome {
                width: 66%;
            }

            .cpfCnpj {
                width: 33%;
            }
        }

        .dados {
            display: flex;
            justify-content: flex-start;
            gap: 26px;

            .el-input,
            .el-select,
            .el-date-picker {
                width: 150px;
            }
        }
    }
    .box {
        display: grid;
        grid-template-columns: auto 423px;
    }

    .upload-demo {
        padding: 10px;
    }

    @media (max-width: 1126px) {
        .box {
            display: flex;
            flex-wrap: wrap;
        }
    }
}

.el-collapse-item__arrow {
    width: 0px;
    color: var(--white);
}

.el-form-item__label {
    margin-bottom: -10px;
}

.el-collapse-item__content {
    padding-bottom: 0px;
}

.erro {
    color: red !important;
}

.erro-borda {
    border-radius: 4px;
    border: 1px solid red;
}
.el-upload {
    flex: 1;
    .el-icon-upload {
        font-size: 40px;
        margin: 0px;
    }
}

.el-upload-dragger {
    width: 558px !important;
}
.mapa {
    height: 150px;
    border-radius: 4px;
    overflow: hidden;
}
.box-direita {
    display: flex;
    flex-direction: column;
    justify-content: center;
}
</style>
